import { useQuery, type ApolloError } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { type AcademicRefereeData } from '../../../../Monitor/graphql';
import { type RefereeConfirmation } from '../../../DRCAssessment';

const GET_ACADEMIC_REFEREE = gql`
  query ($id: ID!) {
    application(id: $id) {
      academicReferees {
        _id
        valid
        selectedToHkpfs
        title
        name {
          surname
          givenName
        }
        institution
        position
        relationship
        email
        referenceReport {
          name
          id
          link
        }
      }
    }
  }
`;

type GetAcademicReferee = {
  academicReferees: AcademicRefereeData[]; // data for display
  confirmations: RefereeConfirmation[]; // data for modification
  loading: boolean;
  error: ApolloError | undefined;
  refetch: () => void;
};

export const useGetAcademicReferee = (
  applicationId: string,
): GetAcademicReferee => {
  const { data, loading, error, refetch } = useQuery(GET_ACADEMIC_REFEREE, {
    variables: { id: applicationId },
    fetchPolicy: 'network-only',
    skip: !applicationId,
  });

  const academicReferees: AcademicRefereeData[] =
    data?.application?.academicReferees ?? [];

  const confirmations: RefereeConfirmation[] = (academicReferees ?? [])
    ?.filter(item => item?._id)
    .map(item => {
      return {
        academicRefereeId: item?._id ?? '',
        valid: item?.valid ?? false,
        selectedToHkpfs: item?.selectedToHkpfs ?? false,
      };
    });

  return {
    academicReferees,
    confirmations,
    loading,
    error,
    refetch,
  };
};
